//src/pages/ForgotPassword.tsx
import React, { useState } from "react";
import { Box, TextField, Button, Typography, Alert, CircularProgress } from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email.trim());
      setMessage("Password reset link sent! Please check your inbox.");
    } catch (err: any) {
      console.error("Reset password error:", err);
      const msg =
        err?.code === "auth/user-not-found"
          ? "No account found with that email address."
          : err?.message || "Failed to send password reset email.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        p: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          width: "100%",
          maxWidth: 420,
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom align="center">
          Reset your password
        </Typography>

        <Typography variant="body2" align="center" sx={{ mb: 3, color: "text.secondary" }}>
          Enter your email address and we’ll send you a link to reset your password.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {message && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {message}
          </Alert>
        )}

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <form onSubmit={handleSubmit}>
            <TextField
              label="Email"
              type="email"
              fullWidth
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{ mt: 2, mb: 1 }}
              disabled={loading}
            >
              Send reset link
            </Button>
          </form>
        )}

        <Typography variant="body2" sx={{ mt: 2, textAlign: "center" }}>
          <Link to="/login">Back to login</Link>
        </Typography>
      </Box>
    </Box>
  );
}
